export default {
  articles: "Articles",
  categories: "Categories",
  tags: "Tags",
  drafts: "Drafts",
};
